export default "__VITE_ASSET__c1b1d112__"